import { GatewayInfoSocieteOrias } from "@conformite/gateway";
import {
  activitesFromEntreprise,
  isIas,
  isIobsp,
} from "@endya-conformite/ui-kit";
import { Assujetti } from "@src/store/store.definition";
import { useEntreprises } from "@src/store/store.entreprise";

export const getAssujettiAvancementFromCategories =
  (categories: GatewayInfoSocieteOrias.Categorie[]) =>
  (assujetti: Assujetti): number => {
    const formToKeep = [
      assujetti.avancement.honorabilite,
      isIas(categories)
        ? [
            assujetti.avancement.capaciteProfessionnelleIas,
            assujetti.avancement.formationContinueIas,
          ]
        : [],
      isIobsp(categories)
        ? [
            assujetti.avancement.capaciteProfessionnelleIobsp,
            assujetti.avancement.formationContinueIobsp,
          ]
        : [],
    ].flat();
    return Math.floor(
      formToKeep.reduce<number>((acc, curr) => acc + (curr ?? 0), 0) /
        formToKeep.length
    );
  };
export const useAssujetisAvancement = () => {
  const { entreprisesBySiren } = useEntreprises();
  return {
    getAssujetisAvancement: (assujetti: Assujetti): number => {
      const entreprise = entreprisesBySiren?.[assujetti.sirenCompany];
      if (!entreprise) return 0;
      const categories = activitesFromEntreprise(entreprise);
      return getAssujettiAvancementFromCategories(categories)(assujetti);
    },
  };
};
